<template>
    <div class="insurance">
       <div class="header">
        <div class="title">中国人寿财险</div>
        <div class="headerContent">
            <div class="img">
                <img :src="require('@/static/img/wode_bapxian.png')" alt="">
            </div>
            <div class="headerInf">
                <div>
                    <div>姓名:{{userName}}</div>
                    <div>状态:有效</div>
                </div>
                <div>2024-10-01 至 2025-10-01</div>
            </div>
        </div>
        <div class="money"> 
            <div>
                <div></div>
                <div></div>
            </div>
            <div>
                <div>余额：￥2334.00 元</div>
                <div></div>
            </div>
        </div>
       </div>
       <!--
       <div class="jd">
            <img :src="require('@/static/img/jd.jpg')" alt="">
       </div>
       -->
       <div style="margin-top:10px;"></div>

       <van-cell-group>
           <van-cell title="修改密码" icon="eye-o"  is-link to="/pay/payCode?hasPwd=y"/>
           <van-cell title="修改手机号" icon="phone-o"  is-link @click="toDPay"/>
           <van-cell title="支付明细" icon="gold-coin-o" is-link to="/pay/payList"/>
           <van-cell title="理赔记录" icon="todo-list-o" is-link @click="toClaim"/>
       </van-cell-group>     

       <van-cell-group>
        <!--<van-cell title="药店直付" icon="shield-o"  is-link @click="toDPay"/>
        <van-cell title="拍照理赔" icon="photo-o" is-link @click="toClaim"/>
        <van-cell title="在线问诊" icon="todo-list-o" is-link to="/zxwz/zxwzPage"/>-->
            <van-cell title="关于" icon="more-o" value="版本V1.0.0"  />
            <van-cell title="用户协议" icon="envelop-o" is-link to="/other/user_agee"/>
       </van-cell-group>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import InsuranceCard from '@/components/InsuranceCard.vue';
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {
          userName:'11',
          userPlnCode:'',
      };
    },
    methods: {
        toClaim()
		{
			//this.toPukangByH5("KSLP-LPJL");
			window.location.href = "https://pk-pl-h5-test.pukangbao.com/storeCollectionTP?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
		},
		toDPay(){
			//this.toPukangByH5("SMZF");
			window.location.href = "https://pk-pl-h5-test.pukangbao.com/scanning-code-page?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
		},        
    },
    computed: {},
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.userName = sessionStorage.getItem('cstFullName')||'杨长发';
                
        this.userPlnCode = sessionStorage.getItem('userPlnCode');
    },
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.insurance {
    background-color: #f2f2f4;

}
.header {
    background-color:cornflowerblue;
    color: #fff;
    padding: 18px 15px;
    margin: 5px;
    border-radius: 7px;
    .title {
        text-align: left;
        font-size: 18px;
    }
    .headerContent {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        .img{
            width: 70px;
            padding-left: 15px;
            padding-top: 10px;
            img {
                border-radius: 50%;
                width: 100%;
            }
        }    
        .headerInf{
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            flex-wrap: nowrap;
            width: 220px;
            >div:first-child {
                display: flex;
                justify-content: space-around;
            }
        }
        
    }
    .money {
            display: flex;
            justify-content: space-between;
            margin: 0px 32px;
            font-size: 13px;
            height: 26px;
            >div {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
            }
        }
}
.jd {
    margin: 20px 0;
    img {
        width: 100%;    
    }
}
.van-cell--clickable {
    margin-top: 4px;
}
.insurance{
    text-align: left;
}
    .van-cell-group {
        margin-top: 8px;
    }
</style>
